// extracted by mini-css-extract-plugin
export default {"container":"dWKkf","content":"hML-7"};